import { AdminTenantLocation } from '@hakimo-ui/hakimo/types';
import { BasicPanel } from '@hakimo-ui/hakimo/ui-elements';
import { Table } from '@hakimo-ui/hakimo/ui-table';
import { useRowNavigation } from '@hakimo-ui/hakimo/util';
import { Alert } from '@hakimo-ui/shared/ui-base';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getLocationsTableData } from '../util';

interface Props {
  locations: AdminTenantLocation[];
  supportUserEmail: string | null;
  onClickCreate?: () => void;
}

export function LocationsTableCard(props: Props) {
  const { locations, supportUserEmail } = props;
  const { tenantId } = useParams<{ tenantId: string }>();
  const onClickRow = useRowNavigation(`/tenants-admin/${tenantId}/locations`);

  const tableData = useMemo(
    () => getLocationsTableData(locations, onClickRow),
    [locations, onClickRow]
  );

  if (locations.length === 0) {
    return (
      <BasicPanel title="Locations">
        <div className="p-4">
          <Alert type="info" size="small">
            Please access hakimo portal with tenant support account{' '}
            {supportUserEmail && <strong>{supportUserEmail}</strong>} to create
            location for this tenant.
          </Alert>
        </div>
      </BasicPanel>
    );
  }

  return (
    <BasicPanel title="Locations">
      <Table data={tableData} embedded />
    </BasicPanel>
  );
}

export default LocationsTableCard;
